import React from 'react';
import { useSite } from '../context/SiteContext';

const Stats = () => {
  const { stats = [] } = useSite();
  return (
    <section id="stats" className="section pt-0">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="rounded-3xl border border-white/8 bg-[#080b13] p-8 md:p-10 relative overflow-hidden">
          <div
            aria-hidden
            className="absolute inset-0 bg-grid mask-radial opacity-40"
          />
          <div className="relative grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-6">
            {stats.map((s, i) => {
              const grads = ['grad-text', 'grad-text-pink', 'grad-text-amber', 'grad-text-teal'];
              return (
                <div key={s.label} className="text-center md:text-left">
                  <div className="text-4xl md:text-5xl font-bold text-white tracking-tight">
                    <span className={grads[i % grads.length]}>{s.value}</span>
                  </div>
                  <div className="mt-2 text-xs md:text-sm text-slate-400 uppercase tracking-widest">
                    {s.label}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
